(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7466],{

/***/ 23208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/contacts",
      function () {
        return __webpack_require__(70753);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5616);
/* harmony import */ var _mui_material_Drawer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77533);
/* harmony import */ var _contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54403);
/* harmony import */ var _contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21609);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);














function TemporaryDrawer(param, ref) {
    let { data  } = param;
    const [state, setState] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
        right: false
    });
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const toggleDrawer = (anchor, open)=>(event)=>{
            if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return;
            }
            setState({
                ...state,
                [anchor]: open
            });
        };
    function toggleDrawerParent(anchor, open) {
        setState({
            ...state,
            [anchor]: open
        });
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, ()=>({
            // 暴露给父组件的方法
            toggleDrawerParent
        }));
    const list = (anchor)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            sx: {
                width: anchor === "top" || anchor === "bottom" ? "auto" : 300
            },
            role: "presentation",
            onClick: toggleDrawer(anchor, false),
            onKeyDown: toggleDrawer(anchor, false),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactsInfo),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().arrow),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            icon: "mdi:chevron-right"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().top),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().pic),
                                children: data.firstName.charAt(0)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().name),
                                children: data.firstName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contentBox),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().containers),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            icon: "mdi:phone-outline"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().name),
                                                children: t("Numbers")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().number),
                                                children: [
                                                    data.phones instanceof Array ? data.phones[0].field : "",
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().containers),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            icon: "mdi:email"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().name),
                                                children: t("Email")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_contactsInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().number),
                                                children: data.emailAddresses instanceof Array ? data.emailAddresses[0].field : ""
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Drawer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            anchor: "right",
            open: state["right"],
            onClose: toggleDrawer("right", false),
            children: list("right")
        })
    });
}
TemporaryDrawer = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(TemporaryDrawer);
/* harmony default export */ __webpack_exports__["Z"] = (TemporaryDrawer);


/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 19798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toExcel; }
/* harmony export */ });
/* harmony import */ var xlsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84105);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_0__);


function s2ab(s) {
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for(let i = 0; i !== s.length; ++i){
        view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
}
function data2ws(data) {
    const ws = {};
    const range = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    };
    for(let R = 0; R !== data.length; ++R){
        for(let C = 0; C !== data[R].length; ++C){
            if (range.s.r > R) range.s.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.r < R) range.e.r = R;
            if (range.e.c < C) range.e.c = C;
            const cell = {
                v: data[R][C]
            };
            if (cell.v == null) continue;
            const cellRef = xlsx__WEBPACK_IMPORTED_MODULE_1__/* .utils.encode_cell */ .P6.encode_cell({
                c: C,
                r: R
            });
            if (typeof cell.v === "number") cell.t = "n";
            else if (typeof cell.v === "boolean") cell.t = "b";
            else if (cell.v instanceof Date) {
                cell.t = "n";
                cell.z = xlsx__WEBPACK_IMPORTED_MODULE_1__/* .SSF._table[14] */ .kS._table[14];
            } else {
                cell.t = "s";
            }
            ws[cellRef] = cell;
        }
    }
    if (range.s.c < 10000000) {
        ws["!ref"] = xlsx__WEBPACK_IMPORTED_MODULE_1__/* .utils.encode_range */ .P6.encode_range(range);
    }
    return ws;
}
function Workbook() {
    if (!(this instanceof Workbook)) {
        return new Workbook();
    }
    this.SheetNames = [];
    this.Sheets = {};
}
/*
 * th => 表头
 * data => 数据
 * fileName => 文件名
 * fileType => 文件类型
 * sheetName => sheet页名
 */ //导出封装好的方法
function toExcel(param) {
    let { th , data , fileName , fileType , sheetName  } = param;
    data.unshift(th);
    const wb = new Workbook();
    const ws = data2ws(data);
    sheetName = sheetName || "sheet1";
    wb.SheetNames.push(sheetName);
    wb.Sheets[sheetName] = ws;
    fileType = fileType || "xlsx";
    var wbout = xlsx__WEBPACK_IMPORTED_MODULE_1__/* .write */ .cW(wb, {
        bookType: fileType,
        bookSST: false,
        type: "binary"
    });
    fileName = fileName || "列表";
    (0,file_saver__WEBPACK_IMPORTED_MODULE_0__.saveAs)(new Blob([
        s2ab(wbout)
    ], {
        type: "application/octet-stream"
    }), "".concat(fileName, ".").concat(fileType));
}


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 76039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useAndroidDevicePagedData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95629);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26771);




/** INSTALLED_APP 按包名去重，兼容 bundleid / bundleId */ function getAppBundleId(item) {
    return (item === null || item === void 0 ? void 0 : item.bundleid) || (item === null || item === void 0 ? void 0 : item.bundleId) || "";
}
function dedupeInstalledApps(items) {
    const seen = new Set();
    const result = [];
    for (const item of items){
        const key = getAppBundleId(item);
        if (key) {
            if (seen.has(key)) continue;
            seen.add(key);
        }
        result.push(item);
    }
    return result;
}
/**
 * Android Cloud / Local 分页列表 Hook，设备切换时重置分页并取消旧请求。
 *
 * @param {Object} options
 * @param {'local'|'cloud'} options.source - 数据源：Local 或 Gcloud
 * @param {string} options.category - 接口 category 参数
 * @param {number} options.limit - 每页条数
 * @returns {{ context: Object|null, data: Array, loading: boolean, total: number, loadNext: Function, reload: Function, setDateRange: Function }}
 */ function useAndroidDevicePagedData(param) {
    let { source , category , limit  } = param;
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const [context, setContext] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const revisionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const pageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        offset: 0,
        maxNum: false,
        loading: false
    });
    /** @type {React.MutableRefObject<{ startTime: number, endTime: number } | null>} 日期筛选区间（毫秒） */ const dateRangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const loadPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(offset) {
        let scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scopeRef.current, revision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : revisionRef.current;
        if (!scope || pageRef.current.loading || pageRef.current.maxNum) return;
        pageRef.current.loading = true;
        const { context: scopedContext , signal , isCurrent  } = scope;
        const request = source === "local" ? src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getLocalAndroidAll */ .gH : src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getGcloudAll */ .U1;
        const params = {
            category,
            offset,
            limit
        };
        if (source === "local") params.deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readLocalDeviceUdid */ .S)(scopedContext);
        if (source === "cloud" && (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.physicalDeviceKey)) {
            params.deviceUdid = scopedContext.physicalDeviceKey;
        }
        // 日期筛选走接口：不筛选时不传，请求与改动前一致
        const range = dateRangeRef.current;
        if (range) {
            if (range.startTime != null) params.startTime = range.startTime;
            if (range.endTime != null) params.endTime = range.endTime;
        }
        try {
            var ref;
            const response = await request({
                username: source === "local" ? (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readUserEmail */ .t)() : (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.username) || "",
                params
            }, {
                signal
            });
            if (!isCurrent() || revision !== revisionRef.current) return;
            const contents = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.contents;
            if (contents) {
                setData((old)=>{
                    const merged = offset === 0 ? [
                        ...contents
                    ] : [
                        ...old,
                        ...contents
                    ];
                    return category === "INSTALLED_APP" ? dedupeInstalledApps(merged) : merged;
                });
                setTotal(response.data.totalCount || 0);
                pageRef.current.offset = offset;
                if (contents.length < limit) pageRef.current.maxNum = true;
            } else {
                pageRef.current.maxNum = true;
            }
            setLoading(false);
        } catch (error) {
            if (isCurrent() && revision === revisionRef.current && (error === null || error === void 0 ? void 0 : error.code) !== "ERR_CANCELED") {
                ;
                setLoading(false);
            }
        } finally{
            if (isCurrent() && revision === revisionRef.current) pageRef.current.loading = false;
        }
    }, [
        category,
        limit,
        source
    ]);
    // 设备切换：重置分页 state 并从第一页重新请求
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, scope)=>{
        scopeRef.current = scope;
        revisionRef.current += 1;
        dateRangeRef.current = null;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        setContext(scope.context);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]));
    const loadNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const page = pageRef.current;
        if (!page.maxNum && !page.loading) loadPage(page.offset + limit);
    }, [
        limit,
        loadPage
    ]);
    const reload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const scope = scopeRef.current;
        if (!scope) return;
        revisionRef.current += 1;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]);
    /**
   * 设置日期筛选区间并重新从第一页拉取（区间由接口过滤，不是本地过滤）。
   * @param {{ startTime: number, endTime: number } | null} range - 毫秒时间戳；null 表示清除筛选
   */ const setDateRange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((range)=>{
        dateRangeRef.current = range;
        reload();
    }, [
        reload
    ]);
    return {
        context,
        data,
        loading,
        total,
        loadNext,
        reload,
        setDateRange
    };
}


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 70753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2202);
/* harmony import */ var _mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87109);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21609);
/* harmony import */ var src_core_components_contacts_info__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79756);
/* harmony import */ var src_core_components_to_excel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19798);
/* harmony import */ var src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76039);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9473);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34745);
/* harmony import */ var pinyin_pro__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54457);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74743);






// ** Icon Imports









const getFirstLetter = (name)=>{
    if (!name) return "#";
    const py = (0,pinyin_pro__WEBPACK_IMPORTED_MODULE_11__/* .pinyin */ .N)(name, {
        toneType: "none",
        nonZh: "remove"
    });
    const firstLetter = py.charAt(0);
    return /[a-zA-Z]/.test(firstLetter) ? firstLetter.toUpperCase() : "#";
};
const classifyContacts = (contacts)=>{
    const map = {};
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ#".split("").forEach((key)=>{
        map[key] = [];
    });
    contacts.forEach((item)=>{
        map[getFirstLetter(item.name)].push(item);
    });
    Object.values(map).forEach((items)=>{
        items.sort((a, b)=>{
            const pyA = (0,pinyin_pro__WEBPACK_IMPORTED_MODULE_11__/* .pinyin */ .N)(a.name || "", {
                toneType: "none"
            });
            const pyB = (0,pinyin_pro__WEBPACK_IMPORTED_MODULE_11__/* .pinyin */ .N)(b.name || "", {
                toneType: "none"
            });
            return pyA.localeCompare(pyB);
        });
    });
    return Object.entries(map).map((param)=>{
        let [type, arr] = param;
        return {
            type,
            arr
        };
    });
};
const Contacts = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const [Basic, setBasic] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (true) {
            const val = window.localStorage.getItem("Basic");
            setBasic(val == null || val == 0);
        }
    }, []);
    Basic == null || Basic == 0 ? true : false;
    const childRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const [initContacts, setInitContacts] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    // 联系人信息
    const [userInfo, setUserInfo] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        firstName: "",
        name: ""
    });
    // 联系人数组
    const [useContactsPeople, setContactsPeople] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { context , data: contactRecords , loading: isLoading , loadNext  } = (0,src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_6__/* .useAndroidDevicePagedData */ .v)({
        source: "cloud",
        category: "CONTACT",
        limit: 50
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const grouped = classifyContacts(contactRecords);
        setInitContacts(grouped);
        setContactsPeople(grouped);
    }, [
        contactRecords
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setUserInfo({
            firstName: "",
            name: ""
        });
    }, [
        context === null || context === void 0 ? void 0 : context.requestKey
    ]);
    let getContactsInfo = (info)=>{
        // 当前点击联系人信息
        setUserInfo({
            ...info,
            firstName: info.name,
            phones: [
                {
                    field: info.phone
                }
            ]
        });
        // 打开抽屉
        childRef.current.toggleDrawerParent("right", true);
    };
    // 处理搜索联系人人
    const handleFilter = (e)=>{
        let value = e.target.value;
        if (value === "") {
            setContactsPeople(initContacts);
            return;
        }
        // 搜索过滤
        let filterData = initContacts.map((item)=>{
            return {
                type: item.type,
                arr: item.arr.filter((children)=>{
                    return children.name.toUpperCase().indexOf(value.toUpperCase()) !== -1;
                })
            };
        });
        setContactsPeople(filterData);
    };
    // 导出
    function formatJson(filterVal, jsonData) {
        return jsonData.map((v)=>filterVal.map((j)=>v[j]));
    }
    // 处理导出数据
    const toexcel = ()=>{
        const th = [
            "name",
            "phone",
            "Email"
        ];
        const filterVal = [
            "name",
            "phone",
            "email"
        ];
        let dataSource = [];
        for(let i = 0; i < initContacts.length; i++){
            if (initContacts[i].arr.length > 0) {
                let data = initContacts[i].arr.map((item)=>{
                    try {
                        return {
                            name: item.name,
                            phone: item.phone,
                            email: item.emailAddresses instanceof Array ? item.emailAddresses[0].field : ""
                        };
                    } catch (error) {
                        return {
                            name: "",
                            number: "",
                            email: ""
                        };
                    }
                });
                dataSource = dataSource.concat(data);
            }
        }
        var data1 = formatJson(filterVal, dataSource);
        (0,src_core_components_to_excel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            th,
            data: data1,
            fileName: "export_contacts_data",
            fileType: "xlsx",
            sheetName: "sheet"
        });
    };
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const refs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const addToRefs = (el)=>{
        if (el && !refs.current.includes(el)) {
            refs.current.push(el);
            ;
        }
    };
    const jump = (val)=>{
        for (const item of refs.current){
            if (item.textContent === val) {
                dom.current.scrollTop = item.offsetTop;
                ;
            }
        }
    };
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (scroll >= 100) loadNext();
    }, [
        loadNext,
        scroll
    ]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__/* .setCurrentTab */ .Lw)(t("Contact")));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_9__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[20px] pb-[20px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full text-right mb-[15px] px-[15px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-[14px] text-[#007AFF] cursor-pointer",
                    onClick: ()=>{
                        toexcel();
                    },
                    children: t("export_contacts")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full px-[15px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    fullWidth: true,
                    className: "h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px]",
                    size: "small",
                    onInput: (e)=>{
                        handleFilter(e);
                    },
                    placeholder: t("Search Contacts"),
                    sx: {
                        "& .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
                            border: 0
                        },
                        "& input::placeholder": {
                            fontSize: "16px",
                            color: "#818187",
                            opacity: 100
                        }
                    },
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            position: "start",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                src: "/images/contacts/search.svg",
                                width: 18,
                                height: 18,
                                alt: "search"
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: dom,
                className: "w-full flex flex-1 overflow-auto relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex-1 px-[15px]",
                    children: useContactsPeople.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: item.arr.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                        className: "text-[15px] text-[#8A8A8D] font-[600] border-b border-[#E5E7EB] pt-[25px] pb-[5px]",
                                        ref: addToRefs,
                                        children: item.type
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "",
                                        children: item.arr && item.arr.map((children, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                                className: "py-[12px] border-b border-[#E5E7EB] text-[14px] font-[600] text-[#000000]",
                                                onClick: ()=>{
                                                    getContactsInfo(children);
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "",
                                                        children: children.name
                                                    })
                                                })
                                            }, children.name + i))
                                    })
                                ]
                            }) : null
                        }, item.type))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[15px] flex flex-col items-center justify-center absolute right-0 top-0 h-full pt-[99px]",
                children: [
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "#"
                ].map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[10px] text-[#007AFF] font-[600] cursor-pointer",
                        onClick: ()=>jump(item),
                        children: item
                    }, i))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_contacts_info__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                data: userInfo,
                ref: childRef
            }),
            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
            }) : null,
            initContacts.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center px-4 absolute inset-0 flex justify-center items-center pointer-events-none",
                children: [
                    t("It appears theres no data to show here yet"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("If data exists it may take up to 1 hour to download and appear"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("We suggest checking back in a little while")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Contacts);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ }),

/***/ 54403:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactsInfo":"contactsInfo_contactsInfo__Mt6jB","arrow":"contactsInfo_arrow__V3l0u","top":"contactsInfo_top__dxbuz","pic":"contactsInfo_pic__vEVhj","name":"contactsInfo_name__P_Et5","contentBox":"contactsInfo_contentBox__co2M8","containers":"contactsInfo_containers__1otnj","icon":"contactsInfo_icon__m8c10","text":"contactsInfo_text__i1hEx","number":"contactsInfo_number__MqpVf"};

/***/ }),

/***/ 20067:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 72061:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2251,2552,5675,1954,518,6664,8863,6853,5294,2202,6065,9774,2888,179], function() { return __webpack_exec__(23208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);